import request from './adminRequest'

export const onlineActionApi = {
  listOnlineAction (params) {
    return request.get('/onlineActions', { params: params })
  },
  getOnlineAction (id) {
    return request.get('/onlineActions/' + id)
  },
  saveOnlineAction (data) {
    return request.post('/onlineActions', data)
  },
  updateOnlineAction (id, data) {
    return request.put('/onlineActions/' + id, data)
  },
  deleteOnlineAction (id) {
    return request.delete('/onlineActions/' + id)
  },

}
export default onlineActionApi
